import {
    Container,
    Content,
} from './styled';
import { IoMdEye } from "react-icons/io";

export function CardHolidays({ holiday, onClick }) {
    const {
        nome,
        dt_feriado,
        mensagem
    } = holiday;

    const dataFeriado = dt_feriado.split('-').reverse().join('/');

    return (
        <Container>
            <Content>
                <div>
                    <div>
                        <div className='title'>
                            {dataFeriado}
                        </div>
                    </div>
                    <div>
                        <div className='title'>
                            {nome}
                        </div>
                    </div>
                    <div>
                        <div className='title'>
                            {mensagem}
                        </div>
                    </div>
                </div>
                <div onClick={onClick}>
                    <span>
                        <IoMdEye
                            className='user-settings'
                        />
                    </span>
                </div>
            </Content>
        </Container>
    )
}